import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _AlarmLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M9.15 7.831a2.976 2.976 0 1 1 5.7 0l-1.563 5.211c-.07.234-.105.351-.159.447a1 1 0 0 1-.654.487C12.366 14 12.244 14 12 14s-.366 0-.474-.024a1 1 0 0 1-.654-.487c-.054-.096-.09-.213-.16-.447z" }),
            React.createElement("circle", { cx: 12, cy: 19, r: 2, stroke: "currentColor" })));
}
const AlarmLight = forwardRef(_AlarmLight);
export { AlarmLight };
